// function rotate () {
  $('.booking-bar-search').hide()
  $(window).on("scroll", function() {
    var filterofferpromoY = $('.filter-offer-promo').height() + $('.filter-offer-promo').offset().top - 240;
    var item_do = [];
    var item_dod = [];
    
    if (window.scrollY > filterofferpromoY || window.pageYOffset > filterofferpromoY) {
        $('.booking-bar-skeleton').addClass('d-md-block');
        $('.bar-rotate-offer-promo').addClass('rotate');
      } else {
        // $('.booking-bar-skeleton').removeClass('d-md-block');
        $('.bar-rotate-offer-promo').removeClass('rotate');
      }
      
      $('.dropdown-offer .nav-btn').each(function() {
        item_do.push({'text': $(this).find('span').text(), 'height': $(this).height() + $(this).offset().top -253});
      });

      $('.dropdown-offer-promo-date .offer-promo-title').each(function() {
        item_dod.push({'text': $(this).find('span').text(), 'height': $(this).height() + $(this).offset().top -253});
      });

      // console.log(item_do)


      if(item_do != 0 || item_dod != 0) {
        var item = [];
        item = item_dod.concat(item_do);

        var titleoffersandpromo = $('#offersandpromo').text();
        
        if ($('#title-offer-date-benefit').length) {
          var titleoffersdatebenefit = $('#title-offer-date-benefit').text();
          var titleoffersdatebenefitY =  $('#title-offer-date-benefit').height() + $('#title-offer-date-benefit').offset().top -263;
          $("#select-offer-promo span").text(titleoffersandpromo);
          
          for (i = 0; i < item.length; i++) {
            if ((window.scrollY > item[i].height || window.pageYOffset > item[i].height) && 
            (window.scrollY < titleoffersdatebenefitY || window.pageYOffset < titleoffersdatebenefitY)) {
              $("#select-offer-promo span").text(item[i].text);
              // console.log(item[i].text)
            }
            else if (window.scrollY > item[i].height || window.pageYOffset > item[i].height) {
              $("#select-offer-promo span").text(titleoffersdatebenefit);
            }
          }
        } else {
          for (i = 0; i < item.length; i++) {
            if (window.scrollY > item[i].height || window.pageYOffset > item[i].height) {
              $("#select-offer-promo span").text(item[i].text.replace(' *',''));
            }
          }
        }
      }

      
      // SHOW AFFIX MOBILE OFFERTE-PROMOZIONI
      if($(window).width() < 959 && (window.scrollY > filterofferpromoY || window.pageYOffset > filterofferpromoY)) {
          $('.bar-affix-mobile').addClass('opacity-1 visible');
      } else {
          $('.bar-affix-mobile').removeClass('opacity-1 visible');
      }

      //AFFIX FULLSLIDER OFFER
      if($(window).width() < 959 && (window.scrollY > 40 || window.pageYOffset > 40)) {
        $('.fullslider-offer-promo').addClass('fullslider-offer-scroll');
        $('.fullslider-offer-promo h1').css('font-size', '20px');
        $('.fullslider-offer-promo h2').css('font-size', '18px');
        $('.fullslider-offer-promo h2 svg').css('font-size', '8px');
        $('.fullslider-offer-promo h3').css('font-size', '14px');
        $('.fullslider-offer-promo h3 svg').css('font-size', '14px');
        $('#row_0_1').css('margin-top', '0px')
      } else {
        $('.fullslider-offer-promo').removeClass('fullslider-offer-scroll');
        $('.fullslider-offer-promo h1').css('font-size', '');
        $('.fullslider-offer-promo h2').css('font-size', '');
        $('.fullslider-offer-promo h3').css('font-size', '');
        $('#row_0_1').css('margin-top', '')
      }
  });


  $('a[href*="#"]').on('click', function (e) { 
    e.preventDefault();
    
    $([document.documentElement, document.body]).animate({
      scrollTop: $(this.hash).offset().top -220
    }, 500);
    
    var u = this.hash.replace( /#/, "" );
    
    if ($('.multi-collapse[id*="'+u+'"]').length) {
      $('.multi-collapse[id*="'+u+'"]').addClass('show');
    }
    else if ($('.offer-carousel-tab-slick .nav-item[id*="'+u +'"]').length) {
      $(".offer-carousel-tab-slick").slick('slickGoTo', parseInt($('#'+u).data('slick-index')));
    }

  });

// }


// module.exports = { rotate }
// exports.rotate = rotate
